import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatButtonModule } from "@angular/material/button";
import { MatDialogModule } from "@angular/material/dialog";
import { MatListModule } from "@angular/material/list";
import { MatSortModule } from "@angular/material/sort";
import { NgSelectModule } from "@ng-select/ng-select";
import { NgChartsModule } from "ng2-charts";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TabsModule } from "ngx-bootstrap/tabs";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NgxCurrencyModule } from "ngx-currency";
import { NgxMaskDirective, NgxMaskPipe } from "ngx-mask";
import { SharedModule } from "src/app/shared/shared.module";
import { DocumentoTipoEditComponent } from './components/admin/documento-tipo-edit/documento-tipo-edit.component';
import { DocumentoTipoListComponent } from './components/admin/documento-tipo-list/documento-tipo-list.component';
import { EquipeResponsabilidadeEditComponent } from "./components/admin/equipe-responsabilidade-edit/equipe-responsabilidade-edit.component";
import { EquipeResponsabilidadeListComponent } from "./components/admin/equipe-responsabilidade-list/equipe-responsabilidade-list.component";
import { ExportarListComponent } from './components/admin/exportar-list/exportar-list.component';
import { HistoricoAtualizacoesListComponent } from './components/admin/historico-atualizacoes-list/historico-atualizacoes-list.component';
import { LinkEvidenciaEditComponent } from './components/admin/link-evidencia-edit/link-evidencia-edit.component';
import { LinkEvidenciaListComponent } from './components/admin/link-evidencia-list/link-evidencia-list.component';
import { LinkLegislacaoEditComponent } from './components/admin/link-legislacao-edit/link-legislacao-edit.component';
import { LinkLegislacaoListComponent } from './components/admin/link-legislacao-list/link-legislacao-list.component';
import { ProcessoQuestaoEditComponent } from './components/admin/processo-questao-edit/processo-questao-edit.component';
import { ProcessoQuestaoListComponent } from "./components/admin/processo-questao-list/processo-questao-list.component";
import { ProcessoStatusEditComponent } from "./components/admin/processo-status-edit/processo-status-edit.component";
import { ProcessoStatusListComponent } from "./components/admin/processo-status-list/processo-status-list.component";
import { ProdutoDocumentoEditComponent } from './components/admin/produto-documento-edit/produto-documento-edit.component';
import { ProdutoDocumentoListComponent } from './components/admin/produto-documento-list/produto-documento-list.component';
import { ProdutoEtapaModalidadeEditComponent } from "./components/admin/produto-etapa-modalidade-edit/produto-etapa-modalidade-edit.component";
import { ProdutoEtapaModalidadeListComponent } from "./components/admin/produto-etapa-modalidade-list/produto-etapa-modalidade-list.component";
import { ProdutoModalidadeEditComponent } from './components/admin/produto-modalidade-edit/produto-modalidade-edit.component';
import { ProdutoModalidadeListComponent } from './components/admin/produto-modalidade-list/produto-modalidade-list.component';
import { ProjetoFonteRecursoEditComponent } from "./components/admin/projeto-fonte-recurso-edit/projeto-fonte-recurso-edit.component";
import { ProjetoFonteRecursoListComponent } from "./components/admin/projeto-fonte-recurso-list/projeto-fonte-recurso-list.component";
import { ProjetoMoedaEditComponent } from "./components/admin/projeto-moeda-edit/projeto-moeda-edit.component";
import { ProjetoMoedaListComponent } from "./components/admin/projeto-moeda-list/projeto-moeda-list.component";
import { ProjetoSituacaoEditComponent } from "./components/admin/projeto-situacao-edit/projeto-situacao-edit.component";
import { ProjetoSituacaoListComponent } from "./components/admin/projeto-situacao-list/projeto-situacao-list.component";
import { AbasEditComponent } from './components/processos/abas-edit/abas-edit.component';
import { AbasListComponent } from './components/processos/abas-list/abas-list.component';
import { GrupoEditComponent } from './components/processos/grupo-edit/grupo-edit.component';
import { GrupoListComponent } from './components/processos/grupo-list/grupo-list.component';
import { ProcessoEditComponent } from './components/processos/processo-edit/processo-edit.component';
import { ProcessoLayoutComponent } from './components/processos/processo-layout/processo-layout.component';
import { ProcessoListComponent } from './components/processos/processo-list/processo-list.component';
import { ProcessoQuestoesListComponent } from './components/processos/processo-questoes-list/processo-questoes-list.component';
import { CapacidadeExecucaoEditComponent } from './components/projetos/capacidade-execucao-edit/capacidade-execucao-edit.component';
import { EquipeCapacidadeExecucaoEditComponent } from './components/projetos/equipe-capacidade-execucao-edit/equipe-capacidade-execucao-edit.component';
import { EquipeCapacidadeExecucaoListComponent } from './components/projetos/equipe-capacidade-execucao-list/equipe-capacidade-execucao-list.component';
import { ProjetoDocumentosEditComponent } from './components/projetos/projeto-documentos-edit/projeto-documentos-edit.component';
import { ProjetoDocumentosListComponent } from './components/projetos/projeto-documentos-list/projeto-documentos-list.component';
import { ProjetoEditComponent } from './components/projetos/projeto-edit/projeto-edit.component';
import { ProjetoLayoutComponent } from './components/projetos/projeto-layout/projeto-layout.component';
import { ProjetoListComponent } from './components/projetos/projeto-list/projeto-list.component';
import { ProjetoProdutoEditComponent } from './components/projetos/projeto-produto-edit/projeto-produto-edit.component';
import { ProjetoProdutoListComponent } from './components/projetos/projeto-produto-list/projeto-produto-list.component';
import { PreProjetoRoutes } from "./pre-projeto.routing";
import { EquipeResponsabilidadeResolver } from "./resolver/equipe-responsabilidade.resolver";
import { GrupoInfoProcessoResolver } from "./resolver/grupo-info-processo.resolver";
import { LinkEvidenciaResolver } from "./resolver/link-evidencia.resolver";
import { LinkLegislacaoResolver } from "./resolver/link-legislacao.resolver";
import { PreProjetoExportarResolver } from "./resolver/pre-projeto-exportar.resolver";
import { ProcessoAbasResolver } from "./resolver/processo-abas.resolver";
import { ProcessoCadastroFiltersResolver, ProcessoCadastroResolver } from "./resolver/processo-cadastro.resolver";
import { ProdutoDocumentoResolver } from "./resolver/produto-documento.resolver";
import { ProdutoEtapaModalidadeResolver } from "./resolver/produto-etapa-modalidade.resolver";
import { ProdutoModalidadeResolver } from './resolver/produto-modalidade.resolver';
import { ProjetoCadastroAbasResolver, ProjetoCadastroCombosResolver, ProjetoCadastroFiltersResolver, ProjetoCadastroMenuResolver, ProjetoCadastroResolver } from "./resolver/projeto-cadastro.resolver";
import { ProjetoDocumentoFiltersResolver, ProjetoDocumentoResolver } from "./resolver/projeto-documento.resolver";
import { ProjetoEquipeResolver } from "./resolver/projeto-equipe.resolver";
import { ProjetoFonteRecursoResolver } from "./resolver/projeto-fonte-recurso.resolver";
import { ProjetoMoedaResolver } from "./resolver/projeto-moeda.resolver";
import { ProjetoProdutoFiltersResolver, ProjetoProdutoResolver } from "./resolver/projeto-produto.resolver";
import { ProjetoSituacaoResolver } from "./resolver/projeto-situacao.resolver";
import { AtributoProcessoQuestaoService } from "./services/atributos-processo-questao.service";
import { DocumentoTipoService } from "./services/documento-tipo.service";
import { EquipeResponsabilidadeService } from "./services/equipe-responsabilidade.service";
import { LinkEvidenciaService } from "./services/link-evidencia.service";
import { LinkLegislacaoService } from "./services/link-legislacao.service";
import { PreProjetoExportarService } from "./services/pre-projeto-exportar.service";
import { ProcessoAbasService } from "./services/processo-abas.service";
import { ProcessoCadastroService } from "./services/processo-cadastro.service";
import { ProcessoGrupoService } from "./services/processo-grupo.service";
import { ProcessoQuestaoService } from "./services/processo-questao.service";
import { ProcessoQuestoesService } from "./services/processo-questoes.service";
import { ProcessoStatusService } from "./services/processo-status.service";
import { ProdutoDocumentoService } from "./services/produto-documento.service";
import { ProdutoEtapaModalidadeService } from "./services/produto-etapa-modalidade.service";
import { ProdutoModalidadeService } from './services/produto-modalidade.service';
import { ProjetoCadastroService } from "./services/projeto-cadastro.service";
import { ProjetoDocumentoService } from "./services/projeto-documentos.service";
import { ProjetoEquipeCapacidadeExecucaoService } from "./services/projeto-equipe-capacidade-execucao.service";
import { ProjetoFonteRecursoService } from "./services/projeto-fonte-recurso.service";
import { ProjetoMoedaService } from "./services/projeto-moeda.service";
import { ProjetoProdutoService } from "./services/projeto-produto.service";
import { ProjetoSituacaoService } from "./services/projeto-situacao.service";
import { ProjetoLegislacaoListComponent } from './components/projetos/projeto-legislacao-list/projeto-legislacao-list.component';
import { ProjetoLegislacaoService } from "./services/projeto-legislacao.service";
import { ProjetoAbasEditComponent } from './components/projetos/projeto-abas-edit/projeto-abas-edit.component';
import { ProjetoTramitacaoEditComponent } from './components/projetos/projeto-tramitacao-edit/projeto-tramitacao-edit.component';
import { ProjetoTramitacaoService } from "./services/projeto-tramitacao.service";
import { ProjetoTramitacaoResolver } from "./resolver/projeto-tramitacao.resolver";
import { CustoEditComponent } from './components/projetos/custo-edit/custo-edit.component';
import { ProjetoCustoService } from "./services/projeto-custo.service";
import { ImpactoOrcamentarioListComponent } from './components/projetos/impacto-orcamentario-list/impacto-orcamentario-list.component';
import { ProjetoImpactoOrcamentarioService } from "./services/projeto-impacto-orcamentario.service";
import { ImpactoOrcamentarioEditComponent } from './components/projetos/impacto-orcamentario-edit/impacto-orcamentario-edit.component';
import { ProjetoImpactoOrcamentarioResolver } from "./resolver/projeto-impacto-orcamentario.resolver";
import { ProjetoRelatorioComponent } from "./components/projetos/projeto-relatorio/projeto-relatorio.component";
import { ProjetoRelatorio1Component } from "./components/projetos/projeto-relatorio-1/projeto-relatorio-1.component";
import { ProjetoRelatorio2Component } from "./components/projetos/projeto-relatorio-2/projeto-relatorio-2.component";
import { ProjetoRelatorioService } from "./services/projeto-relatorio.service";
import { ProjetoRelatorio3Component } from "./components/projetos/projeto-relatorio-3/projeto-relatorio-3.component";
import { ProjetoRelatorio4Component } from "./components/projetos/projeto-relatorio-4/projeto-relatorio-4.component";

@NgModule({
  declarations: [
    ProjetoSituacaoListComponent,
    ProjetoSituacaoEditComponent,
    ProjetoFonteRecursoListComponent,
    ProjetoFonteRecursoEditComponent,
    ProjetoMoedaEditComponent,
    ProjetoMoedaListComponent,
    ProdutoEtapaModalidadeListComponent,
    ProdutoEtapaModalidadeEditComponent,
    ProcessoStatusListComponent,
    ProcessoStatusEditComponent,
    EquipeResponsabilidadeEditComponent,
    EquipeResponsabilidadeListComponent,
    DocumentoTipoListComponent,
    DocumentoTipoEditComponent,
    ProdutoDocumentoEditComponent,
    ProdutoDocumentoListComponent,
    LinkEvidenciaListComponent,
    LinkEvidenciaEditComponent,
    LinkLegislacaoEditComponent,
    LinkLegislacaoListComponent,
    ProjetoListComponent,
    ExportarListComponent,
    ProcessoQuestaoListComponent,
    ProcessoQuestaoEditComponent,
    ProcessoListComponent,
    ProcessoLayoutComponent,
    ProcessoEditComponent,
    ProdutoModalidadeListComponent,
    ProdutoModalidadeEditComponent,
    HistoricoAtualizacoesListComponent,
    GrupoListComponent,
    ProcessoQuestoesListComponent,
    AbasListComponent,
    ProjetoLayoutComponent,
    ProjetoEditComponent,
    GrupoEditComponent,
    ProjetoDocumentosListComponent,
    ProjetoDocumentosEditComponent,
    AbasEditComponent,
    ProjetoProdutoListComponent,
    ProjetoProdutoEditComponent,
    EquipeCapacidadeExecucaoListComponent,
    CapacidadeExecucaoEditComponent,
    EquipeCapacidadeExecucaoEditComponent,
    ProjetoLegislacaoListComponent,
    ProjetoAbasEditComponent,
    ProjetoTramitacaoEditComponent,
    CustoEditComponent,
    ImpactoOrcamentarioListComponent,
    ImpactoOrcamentarioEditComponent,
    ProjetoRelatorioComponent,
    ProjetoRelatorio1Component,
    ProjetoRelatorio2Component,
    ProjetoRelatorio3Component,
    ProjetoRelatorio4Component,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CollapseModule.forRoot(),
    NgSelectModule,
    BsDatepickerModule.forRoot(),
    NgxMaskDirective,
    NgxMaskPipe,
    NgChartsModule,
    TabsModule.forRoot(),
    TooltipModule.forRoot(),
    NgxCurrencyModule,
    MatButtonModule,
    MatBottomSheetModule,
    MatListModule,
    MatDialogModule,
    DragDropModule,
    MatSortModule,
    PreProjetoRoutes,
    SharedModule,
  ],
  providers: [
    ProjetoSituacaoService,
    ProjetoFonteRecursoService,
    ProjetoFonteRecursoResolver,
    ProjetoSituacaoResolver,
    ProjetoMoedaService,
    ProjetoMoedaResolver,
    ProdutoEtapaModalidadeService,
    ProdutoEtapaModalidadeResolver,
    ProcessoStatusService,
    EquipeResponsabilidadeService,
    EquipeResponsabilidadeResolver,
    DocumentoTipoService,
    ProdutoDocumentoService,
    ProdutoDocumentoResolver,
    LinkEvidenciaService,
    LinkEvidenciaResolver,
    LinkLegislacaoService,
    LinkLegislacaoResolver,
    ProjetoCadastroService,
    ProjetoCadastroFiltersResolver,
    PreProjetoExportarService,
    PreProjetoExportarResolver,
    ProcessoQuestaoService,
    AtributoProcessoQuestaoService,
    ProcessoCadastroService,
    ProcessoCadastroResolver,
    ProcessoCadastroFiltersResolver,
    ProdutoModalidadeService,
    ProdutoModalidadeResolver,
    ProcessoGrupoService,
    ProcessoQuestoesService,
    ProcessoAbasService,
    GrupoInfoProcessoResolver,
    ProjetoDocumentoService,
    ProjetoDocumentoResolver,
    ProjetoDocumentoFiltersResolver,
    ProcessoAbasResolver,
    ProjetoEquipeCapacidadeExecucaoService,
    ProjetoEquipeResolver,
    ProjetoCadastroMenuResolver,
    ProjetoCadastroCombosResolver,
    ProjetoProdutoService,
    ProjetoProdutoResolver,
    ProjetoProdutoFiltersResolver,
    ProjetoCustoService,
    ProjetoImpactoOrcamentarioService,
    ProjetoImpactoOrcamentarioResolver,
    ProjetoLegislacaoService,
    ProjetoCadastroAbasResolver,
    ProjetoTramitacaoService,
    ProjetoTramitacaoResolver,
    ProjetoCadastroResolver,
    ProjetoRelatorioService
  ],
})
export class PreProjetoModule {}
